// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__lwGS6","description":"PatientConsentPreview_description__19O72"};